import { render, staticRenderFns } from "./ProductsLayout.vue?vue&type=template&id=6f46b9da&scoped=true&"
import script from "./ProductsLayout.vue?vue&type=script&lang=js&"
export * from "./ProductsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProductsLayout.vue?vue&type=style&index=0&id=6f46b9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46b9da",
  null
  
)

component.options.__file = "ProductsLayout.vue"
export default component.exports